import { Clock, GitBranch } from "lucide-react"

import { ActionDefinition } from "@/components/automations/types"

export const flowActions: ActionDefinition[] = [
  {
    key: "action__flow_branch",
    name: "Branch",
    description: "Create conditional branches in the automation",
    category: "flow",
    nodeType: "action",
    icon: GitBranch,
    fields: [
      {
        key: "branches",
        label: "Check the following branches in order",
        inputType: "branch_conditions",
        required: true,
        filterFieldsSource: "trigger_subject",
        chatValueShape:
          '[{"name":"Matching path","isDefault":false,"condition_group":{"combinator":"and|or","conditions":[{"field":"<filter_fields field>","value":"... or use values: [...]"}]}},{"name":"Otherwise","isDefault":true}]',
        helperText:
          "Define at least two branches. Exactly one must set isDefault to true. Branch IDs and ordering are generated automatically. For non-default conditions, use field names and values returned by fetch_field_options with kind filter_fields.",
      },
    ],
  },
  {
    key: "action__flow_wait",
    name: "Wait",
    description: "Pause the automation for a specified duration",
    category: "flow",
    nodeType: "action",
    icon: Clock,
    fields: [
      {
        key: "wait_value",
        label: "Wait duration",
        inputType: "number",
        required: true,
        helperText: "Maximum wait time: 30 days",
      },
      {
        key: "wait_period",
        label: "Time period",
        inputType: "select",
        required: true,
        options: [
          { value: "seconds", label: "Seconds" },
          { value: "minutes", label: "Minutes" },
          { value: "hours", label: "Hours" },
          { value: "days", label: "Days" },
        ],
      },
    ],
  },
]
